module.exports = "<cat-panel>not-implemented-yet</cat-panel>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-models/components/not-implemented-yet/not-implemented-yet.component.html
// module id = ../../../../../src/app/modules/ui-models/components/not-implemented-yet/not-implemented-yet.component.html
// module chunks = main